import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TablePlaceholder from '../../common/TablePlaceholder'

// Empty-state placeholder for the Enrollments & Billing table, matching Figma:
// - filters applied  -> "No Results" + Clear button
// - search applied    -> "No Results" + try-different hint
// - nothing at all    -> "No Transactions & Enrollments" + marketing link
const EnrollmentsEmptyState = ({ hasFilters, hasSearch, onClearAll, onLearnMore }) => {
  const { t } = useTranslation()

  if (hasFilters) {
    return (
      <TablePlaceholder
        message={t('enrollmentsBilling.emptyState.noResults')}
        description={t('enrollmentsBilling.emptyState.noResultsFilterDescription')}
        actionLabel={t('enrollmentsBilling.emptyState.clear')}
        onAction={onClearAll}
      />
    )
  }

  if (hasSearch) {
    return (
      <TablePlaceholder
        message={t('enrollmentsBilling.emptyState.noResults')}
        description={t('enrollmentsBilling.emptyState.noResultsSearchDescription')}
      />
    )
  }

  return (
    <TablePlaceholder
      message={t('enrollmentsBilling.emptyState.noTransactionsTitle')}
      description={t('enrollmentsBilling.emptyState.noTransactionsDescription')}
      linkLabel={t('enrollmentsBilling.emptyState.learnMoreLink')}
      onLink={onLearnMore}
    />
  )
}

EnrollmentsEmptyState.propTypes = {
  hasFilters: PropTypes.bool,
  hasSearch: PropTypes.bool,
  onClearAll: PropTypes.func,
  onLearnMore: PropTypes.func,
}

export default EnrollmentsEmptyState
